import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const Download: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='verification-container'>
      <div className='verification-content'>
        <div className='verification-card'>
          <div className='verification-icon'>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="32" cy="32" r="32" fill="#177508"/>
              <path d="M32 8V40M24 32L32 40L40 32" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <h1 className='titles large color black'>Download</h1>
          
          <div className='verification-actions'>
            <button 
              className='btn secondary'
              onClick={() => navigate('/')}
            >
              Return to Home
            </button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Download; 